import { Grid } from 'antd';

import { useLayoutViewContext } from '@shared/context';

const { useBreakpoint } = Grid;

const useMobileScreen = () => {
  const { isMobileView, isSharedServiceView } = useLayoutViewContext();

  const breakpoints = useBreakpoint();

  return isMobileView || isSharedServiceView || breakpoints.xs;
};

export default useMobileScreen;
